import * as React from "react"

function CourseDurationHighlight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 166 76" {...props}>
      <title>{"Finish In"}</title>
      <g fill="none" fillRule="evenodd">
        <text
          fontFamily="Helvetica-Bold, Helvetica"
          fontSize={14}
          fontWeight="bold"
          letterSpacing={1.1}
          fill="#E3E833"
          transform="translate(1)"
        >
          <tspan x={46.16} y={14}>
            {"FINISH IN"}
          </tspan>
        </text>
        <path stroke="#E3E833" d="M130.39 8H165v67H1V8h34.184" />
      </g>
    </svg>
  )
}

export default CourseDurationHighlight
